import { useEffect, useState } from 'react';
import { wordpressAPI } from '../services/wordpressApi';
import { isUnderRevision } from '../utils/resourceRevision';
import { decodeHtmlEntities } from '../utils/htmlEntities';

export interface ResourceCurrency {
  title: string;
  underRevision: boolean;
  modified: string | null;
}

export function useResourceCurrency(postIds: number[]): {
  byId: Record<number, ResourceCurrency>;
  ready: boolean;
} {
  const key = [...new Set(postIds.filter((id) => Number.isFinite(id)))].sort((a, b) => a - b).join(',');
  const [byId, setById] = useState<Record<number, ResourceCurrency>>({});
  const [ready, setReady] = useState(() => key.length === 0);

  useEffect(() => {
    if (!key) {
      setById({});
      setReady(true);
      return;
    }
    let cancelled = false;
    setReady(false);
    const ids = key.split(',').map(Number);
    wordpressAPI
      .fetchPosts({ include: key, per_page: ids.length })
      .then((posts) => {
        if (cancelled) return;
        const next: Record<number, ResourceCurrency> = {};
        for (const post of posts) {
          next[post.id] = {
            title: decodeHtmlEntities(post.title.rendered),
            underRevision: isUnderRevision(post.acf?.under_revision),
            modified: post.modified || null,
          };
        }
        setById(next);
        setReady(true);
      })
      .catch(() => {
        if (!cancelled) {
          setById({});
          setReady(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [key]);

  return { byId, ready };
}
